module.exports = __webpack_public_path__ + "assets/df060477f75b020227b8ed0616d836cb.svg";